import * as React from "react";
import { Helmet } from "react-helmet";
import { FaPlay } from "react-icons/fa";
import ModalVideo from "react-modal-video";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import { useScrollTop } from "../hook/useScrollTop";
import ericson from "../images/digital-marketing/ericson.png";
import etisalat from "../images/digital-marketing/etisalat.png";
import huawei from "../images/digital-marketing/huawei.png";
import nec from "../images/digital-marketing/nec.png";
import nokia from "../images/digital-marketing/nokia.png";
import orange from "../images/digital-marketing/orange.png";
import videoBackgroundImg from "../images/digital-marketing/videoback-1.jpg";
import DigitalMarketingServices from "../sections/digital-marketing-sevice";

import SubscribeContact from "../components/subscribeContact";
import bannerImage from "../images/digital-marketing/digital-marketing-banner.jpg";

const DigitalMarketing = () => {
  const [isOpen, setOpen] = React.useState(false);
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Digital Marketing</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={bannerImage}>
        <div className="pt-7 pb-7 text-center">
          <h1 className="fs-56 lh-64 text-capitalize flex align-items-center gilroy-bold pt-7">
            BUILD A DIGITAL MARKETING STRATEGY THAT WORKS
          </h1>
          <p className="fs-16 py-5">
            Every business has a unique path to growth. A customized strategy
            from MWI will help you find it.
          </p>
          <div>
            <a
              href="#service"
              className="text-decoration-none fs-16 text-white text-uppercase d-inline-block mx-4  px-5 py-3 border-yellow gilroy-bold dm-header-btn"
            >
              Our services
            </a>
            <a
              href="/"
              className="text-decoration-none fs-16 text-white text-uppercase d-inline-block mx-4 px-5 py-3 border-yellow gilroy-bold dm-header-btn"
            >
              New Video
            </a>
          </div>
        </div>
      </Header>
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="iSQRb4vzKCw"
        onClose={() => setOpen(false)}
      />
      <section className="container-fluid pt-7 pb-7">
        <section className="ms-35 me-35">
          <DigitalMarketingServices />
        </section>
      </section>
      <section
        style={{
          backgroundImage: `url(${videoBackgroundImg})`,
          height: "500px",
        }}
        className="d-flex align-items-center text-center justify-content-center"
      >
        <div>
          <p className="fs-22 text-white">Learn more about us</p>
          <h3 className="fs-28 gilroy-bold text-white pb-5 text-uppercase">
            SEE WHAT MAKES THE TEAM AT MWI DIFFERENT
          </h3>
          <div
            onClick={() => setOpen(true)}
            className="bg-danger text-white d-flex align-items-center justify-content-center fs-32 rounded-circle cursor-pointer mx-auto mt-3 card-design-2"
            style={{ height: "100px", width: "100px" }}
          >
            <FaPlay className="card-design-2" />
          </div>
        </div>
      </section>
      <section className="container-fluid pt-5 pb-7">
        <section className="ms-47 me-47 mt-7">
          <div className="text-center">
            <p className="fs-20 lh-30">Our clients</p>
            <h2 className="fs-28 lh-40 gilroy-bold pb-7">
              Some of the brands that trust MWI
            </h2>
            <div className="row">
              <div className="col-md-2 my-auto">
                <img
                  src={huawei}
                  loading="lazy"
                  className="digital-marketing-clients card-design-2"
                  alt=""
                />
              </div>

              <div className="col-md-2 my-auto">
                <img
                  src={ericson}
                  loading="lazy"
                  className="digital-marketing-clients card-design-2"
                  alt=""
                />
              </div>

              <div className="col-md-2 my-auto">
                <img
                  src={nokia}
                  loading="lazy"
                  className="digital-marketing-clients card-design-2"
                  alt=""
                />
              </div>

              <div className="col-md-2 my-auto">
                <img
                  src={etisalat}
                  loading="lazy"
                  className="digital-marketing-clients card-design-2"
                  alt=""
                />
              </div>

              <div className="col-md-2 my-auto">
                <img
                  src={orange}
                  loading="lazy"
                  className="digital-marketing-clients card-design-2"
                  alt=""
                />
              </div>

              <div className="col-md-2 my-auto">
                <img
                  src={nec}
                  loading="lazy"
                  className="digital-marketing-clients card-design-2"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>
      </section>
      <SubscribeContact />
      <Footer />
    </>
  );
};

export default DigitalMarketing;
